import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    datosSesion: {
      idUsuario: 0,
      usuario: '',
      nombres: '',
      apellidos: '',
      idPerfil: 0,
      perfil: '',
      idColegio: 0,
      dane: '',
      nit: '',
      nombre: '',
      categoria: '',
      nemo: '',
      resolucion: '',
      direccion: '',
      municipio: '',
      departamento: '',
      telefono: '',
      correo: '',
      bd: '',
      foto: '',
      lectivo: 0,
      idCurso: ''
    }
  },
  mutations: {
    sesion(state, datos){
      state.datosSesion.idUsuario = datos.idUsuario
      state.datosSesion.usuario = datos.usuario
      state.datosSesion.nombres = datos.nombres
      state.datosSesion.apellidos = datos.apellidos
      state.datosSesion.idPerfil = datos.idPerfil
      state.datosSesion.perfil = datos.perfil
      state.datosSesion.idColegio = datos.idColegio
      state.datosSesion.dane = datos.dane
      state.datosSesion.nit = datos.nit
      state.datosSesion.nombre = datos.nombre
      state.datosSesion.categoria = datos.categoria
      state.datosSesion.nemo = datos.nemo
      state.datosSesion.resolucion = datos.resolucion
      state.datosSesion.direccion = datos.direccion
      state.datosSesion.municipio = datos.municipio
      state.datosSesion.departamento = datos.departamento
      state.datosSesion.telefono = datos.telefono
      state.datosSesion.correo = datos.correo
      state.datosSesion.bd = datos.bd
      state.datosSesion.foto = datos.foto
      state.datosSesion.lectivo = datos.lectivo
      state.datosSesion.idCurso = datos.idCurso
    }
  },
  actions: {
  },
  modules: {
  }
})
